import { useState } from 'react';
import { Filter, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export default function FilterPanel({ onApplyFilters, oems = [] }) {
  const [selectedOem, setSelectedOem] = useState('all_oems');
  const [selectedDateRange, setSelectedDateRange] = useState('all');

  const handleApply = () => {
    onApplyFilters({
      oem: selectedOem === 'all_oems' ? undefined : selectedOem,
      dateRange: selectedDateRange
    });
  };

  const handleReset = () => {
    setSelectedOem('all_oems');
    setSelectedDateRange('all');
    onApplyFilters({});
  };

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
            <Filter size={16} />
            Filters:
          </div>

          <Select value={selectedOem} onValueChange={setSelectedOem}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="All OEMs" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all_oems">All OEMs</SelectItem>
              {oems.map(oem => (
                <SelectItem key={oem} value={oem}>{oem}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={selectedDateRange} onValueChange={setSelectedDateRange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Date Range" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Time</SelectItem>
              <SelectItem value="2024">2024</SelectItem>
              <SelectItem value="2025">2025</SelectItem>
              <SelectItem value="2026">2026</SelectItem>
            </SelectContent>
          </Select>

          <div className="flex gap-2 ml-auto">
            <Button onClick={handleApply}>
              Apply Filters
            </Button>
            <Button variant="outline" onClick={handleReset}>
              <RotateCcw size={16} className="mr-2" />
              Reset
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
